export const GET_DEPLOYMENT_PAGE_AGENTS_DATA =
  'GET_DEPLOYMENT_PAGE_AGENTS_DATA';
